/**
 * Typisierung Page - Tabbed view for type classifications
 */

import { useState } from 'react'
import { Layers, Target, Grid3X3, TreeDeciduous, Circle, Tag, BarChart3 } from 'lucide-react'
import { ClassificationTable } from './ClassificationTable'
import type { ClassificationType } from '../types'
import { cn } from '../../lib/utils'

interface TabConfig {
  id: ClassificationType
  label: string
  icon: React.ReactNode
}

const TABS: TabConfig[] = [
  { id: 'region-types', label: 'Regionstypen', icon: <Layers className="w-4 h-4" /> },
  { id: 'county-types', label: 'Kreistypen', icon: <Target className="w-4 h-4" /> },
  { id: 'municipality-types', label: 'Gemeindetypen', icon: <Grid3X3 className="w-4 h-4" /> },
  { id: 'urban-rural-types', label: 'Stadt-Land', icon: <TreeDeciduous className="w-4 h-4" /> },
  { id: 'centrality-types', label: 'Zentralität', icon: <Circle className="w-4 h-4" /> },
  { id: 'text-indicators', label: 'Textkennzeichen', icon: <Tag className="w-4 h-4" /> },
  { id: 'prognos-rating-classes', label: 'Prognos', icon: <BarChart3 className="w-4 h-4" /> },
]

export function TypisierungPage() {
  const [activeTab, setActiveTab] = useState<ClassificationType>('region-types')

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Typisierung</h1>
        <p className="text-gray-500 mt-1">Typklassifikationen aus GV100NAD und externen Quellen</p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200">
        <nav className="flex flex-wrap gap-1" aria-label="Tabs">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={cn(
                'flex items-center gap-2 px-3 py-2.5 text-sm font-medium border-b-2 transition-colors',
                activeTab === tab.id
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              )}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Content */}
      <ClassificationTable classificationType={activeTab} />
    </div>
  )
}
